import PropTypes from 'prop-types';

import {getDataRows, getColumnsForDistributionRows} from './eventsIndexExcelHelpers';

export const exportExcel = (dataExport) => {
    return {
        dataExport: dataExport.flatMap(event => getDataRows(event)),
        filename: 'events',
        parseData: row => row,
        path: 'events.index.path',
        titles: getColumnsForDistributionRows,
    };
};

exportExcel.propTypes = {
    dataExport: PropTypes.array.isRequired,
};
